import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('./views/home.vue'),
      meta: {
        title: '雪谋'
      }
    },
    {
      path: '/about',
      name: 'about',
      alias: '/aboutme',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/about.vue'),
      meta: {
        title: '关于 - 雪谋'
      }
    },
    {
      path: '/404',
      name: '404',
      component: () => import('@/views/404.vue'),
      meta: {
        title: '404 - 雪谋'
      }
    },
    // { // 微信小游戏
    //   path: '/wechat-game',
    //   name: 'wechat-game',
    //   component: () => import('@/views/wechat-game.vue'),
    //   meta: {
    //     title: '微信小游戏 - 雪谋'
    //   }
    // },
    // {
    //   path: '/dashizouwei',
    //   name: 'dashizouwei',
    //   component: () => import('@/views/wechat-game/dashizouwei.vue'),
    //   meta: {
    //     title: '大师走位 - 雪谋'
    //   }
    // },
    { // 魔兽
      path: '/war-map',
      name: 'war-map',
      component: () => import('@/views/war-map.vue'),
      meta: {
        title: '魔兽地图 - 雪谋'
      }
    },
    {
      path: '/panic-befall',
      name: 'panic-befall',
      component: () => import('@/views/war-map/panic-befall.vue'),
      meta: {
        title: '恐慌降临 - 雪谋'
      }
    },
    { // 星际
      path: '/sc-map',
      name: 'sc-map',
      component: () => import('@/views/sc-map.vue'),
      meta: {
        title: '星际地图 - 雪谋'
      }
    },
    {
      path: '/infection-outbreak-beta',
      name: 'infection-outbreak-beta',
      component: () => import('@/views/sc-map/infection-outbreak-beta.vue'),
      meta: {
        title: '感染爆发 Beta - 雪谋'
      }
    },
    {
      path: '/infection-outbreak-alpha',
      name: 'infection-outbreak-alpha',
      component: () => import('@/views/sc-map/infection-outbreak-alpha.vue'),
      meta: {
        title: '感染爆发 Alpha - 雪谋'
      }
    },
    {
      path: '/god-is-dead',
      name: 'god-is-dead',
      component: () => import('@/views/sc-map/god-is-dead.vue'),
      meta: {
        title: '上帝已死 - 雪谋'
      }
    },
    {
      path: '/infection-feast',
      name: 'infection-feast',
      component: () => import('@/views/sc-map/infection-feast.vue'),
      meta: {
        title: '感染盛宴 - 雪谋'
      }
    },
    { // 小米
      path: '/mi-theme',
      name: 'mi-theme',
      component: () => import('@/views/mi-theme.vue'),
      meta: {
        title: '小米主题 - 雪谋'
      }
    },
    {
      path: '/modern',
      name: 'modern',
      component: () => import('@/views/mi-theme/modern.vue'),
      meta: {
        title: 'Modern - 雪谋'
      }
    },
    {
      path: '/flat-design',
      name: 'flat-design',
      component: () => import('@/views/mi-theme/flat-design.vue'),
      meta: {
        title: '扁平化设计 - 雪谋'
      }
    },
    {
      path: '/flat-design-dark',
      name: 'flat-design-dark',
      component: () => import('@/views/mi-theme/flat-design-dark.vue'),
      meta: {
        title: '扁平化设计 黑色 - 雪谋'
      }
    },
    { // 我的世界
      path: '/minecraft-feedback',
      name: 'minecraft-feedback',
      component: () => import('@/views/minecraft/feedback.vue'),
      meta: {
        title: '我的世界玩家群 - 雪谋'
      }
    },
    { // 404重定向，需置于最底部
      path: '*',
      redirect: '/404'
    }
  ]
})